<template>
  <div class="content">
    <h1 class="content__title" v-text="texts.title"></h1>
    <span class="content__details" v-text="texts.subtitle"></span>
    <div class="content__container">
      <main class="main">
        <section class="main__section">
          <h2 class="main__title">Datos del tipo de Atributo</h2>

          <div class="waiting" v-if="loading">
            <img src="/static/img/waiting.gif" alt="Cargando Información" class="waiting__image">
          </div>

          <form class="form" @submit.prevent="saveType" v-if="!loading">
            <div class="form__fielset">

              <div class="form__container form__container--short">
                <label for="name_es" class="form__label form__label--required">Nombre del tipo de atributo</label>
                <input type="text" class="form__input" name="name_es" id="name_es" placeholder="Nombre del tipo de atributo" v-model="type.name_es" v-validate="validation.name_es">
                <span v-show="errors.has('name_es')" class="form__alert">{{ errors.first('name_es') }}</span>
              </div>

              <div class="form__container form__container--short">
                <label for="status_id" class="form__label form__label--required">Estatus</label>
                <div class="form__select-container">
                  <select name="status_id" id="status_id" class="form__select" v-validate="validation.status_id" v-model="type.status_id">
                    <option :value="null">Seleccionar Estatus</option>
                    <option v-for="(status, index) in statusList" :key="index" :value="status.id" v-text="status.name"></option>
                  </select>
                </div>
                <span v-show="errors.has('status_id')" class="form__alert">{{ errors.first('status_id') }}</span>
              </div>

              <input type="submit" class="btn btn__default btn--regular" :value="texts.submit">

            </div>
          </form>
        </section>
      </main>
      <aside class="sidebar">
        <h2 class="sidebar__title">NAVEGACIÓN</h2>
        <router-link class="btn btn--small btn__default" :to="{name: 'attributeTypeList', params: {page: 1}}">Lista de Tipos</router-link>
        <router-link class="btn btn--small btn__default" :to="{name: 'productList', params: {page: 1}}">Lista de Productos</router-link>
        <router-link class="btn btn--small btn__default" :to="{name: 'attributeList', params: {page: 1}}">Lista de Atributos</router-link>
        <router-link v-if="$route.name === 'attributeTypeEdit'" class="btn btn--small btn__default" :to="{name: 'attributeTypeNew'}">Nuevo Tipo</router-link>
      </aside>
    </div>
  </div>
</template>

<script>
import httpService from '@/api/request'
import {validation, typeFields, statusList, texts} from './type.mocks'
export default {
  mixins: [httpService],
  data: function () {
    return {
      validation: validation,
      type: null,
      statusList: statusList
    }
  },
  created: function () {
    this.start()
  },
  watch: {
    '$route.path': function () {
      this.start()
    }
  },
  methods: {
    start: function () {
      if (this.typeId) {
        this.getType()
      }
      if (!this.typeId) {
        this.type = new typeFields()
      }
    },
    getType: function () {
      let httpRequest = {
        params: '',
        module: 'attribute_types'
      }
      this.getById(this.typeId, httpRequest)
        .then(
          type => {
            this.type = type.data
          }
        )
        .catch(
          () => {
            this.$router.push({name: 'attributeTypeNew'})
          }
        )
    },
    saveType: function () {
      this.$validator.validateAll()
        .then(
          response => {
            if (response) {
              let httpRequest = {
                params: '',
                module: 'attribute_types',
                element: this.type
              }
              let request
              if (this.$route.name === 'attributeTypeEdit') {
                request = this.put(this.typeId, httpRequest)
              } else if (this.$route.name === 'attributeTypeNew') {
                request = this.post(httpRequest)
              }
              request.then(
                response => {
                  this.$store.commit('notificate', {
                    title: this.texts.messages.success.title,
                    text: this.texts.messages.success.text,
                    type: 'success'
                  })
                  if (this.$route.name === 'attributeTypeNew') {
                    this.$router.push({name: 'attributeTypeEdit', params: {id: response.data.current_id}})
                  }
                }
              )
            } else {
              this.$store.commit('notificate', {
                title: 'CAMPOS REQUERIDOS',
                text: 'Por favor, revise el formulario, existen campos requeridos que no han sido completados.',
                type: 'warn'
              })
            }
          }
        ).catch(
          error => {
            console.log(error)
          }
        )
    }
  },
  computed: {
    typeId: function () {
      return this.$route.params.id
    },
    loading: function () {
      return this.$route.params.id && !this.type
    },
    texts: function () {
      return texts[this.$route.name]
    }
  }
}
</script>

<style lang="sass">
@import "../../../assets/sass/objects/_btns"
@import "../../../assets/sass/components/layout/_forms"
</style>



// WEBPACK FOOTER //
// src/components/products/attributes/type.edit.vue